import type { ReactNode } from 'react';

import { Notifier, HostTypes } from '@picsart/design-system/components/Notifier';

import { zNotifierHolder } from 'utils/ui-helpers/stackingContexts';

interface NotifierProviderProps {
  children: ReactNode;
}

const NotifierProvider = ({ children }: NotifierProviderProps) => (
  <Notifier zIndex={zNotifierHolder} hostType={HostTypes.Editor}>
    {children}
  </Notifier>
);

export default NotifierProvider;
